import SearchBarTariffa from '../SearchBarTariffa/SearchBarTariffa'
import SearchBarTariffa2 from '../SearchBarTariffa/SearchBarTariffa2'
import React from 'react';
import { connect } from 'react-redux';
import './TariffaList.css'
import { Trans } from 'react-i18next';
import i18n from 'i18next';
//import CheckTariffe from '../CheckTariffe/CheckTariffe'
import axios from 'axios';
import { Component } from 'react';
import {changePositionTariffaEnd,fetchPath,selectNewIndex, selectNewMarkerStart, selectNewMarkerEnd, selectNewMarkerStart2, selectNewMarkerEnd2,changePositionTariffaStart,changepositionStart,changepositionEnd,changeNomeFermataStart,changeNomeFermataEnd} from '../../redux'
//import Arrow from './down-right-arrow.png'
import point from './info.png'
//import TextField from '@material-ui/core/TextField';
//import { red } from '@material-ui/core/colors';
import startFlag from './start.png'
import finishFlag from './finish.png'
import Tooltip from '@material-ui/core/Tooltip';
import Grid from '@material-ui/core/Grid';

//const headers =  { 'Access-Control-Allow-Origin': process.env.REACT_APP_PRODUZIONE_ALLOW }
const headers =   window.tp_headers



class TariffaList extends Component {
    constructor() {
        super();
        this.state = {
            avvertenza : false,
            partenza:  null,
            arrivo: null,
            mezzo: "TRANSIT%2CWALK",
            date: new Date(),
            option: false,
            partenzaArrivo: false,
            buttonPosition: 0,
            accessibilita: false,
            realTime: true,
            json: "",
            numberOfItem: -1,
            key: 0,
            ordinamento:0,
            ricalcolo: 1,
            dataFermate: [],
            alertflag:false,
            dataArrivo : {
                ID: 0,
                NOME: ""
            },
            dataPartenza : {
                ID: 0,
                NOME: ""
            },
            tariffe : {
                AAI : "",
                AAO65 : "",
                AAS : "",
                AMI : "",
                AMO65 : "",
                AMS : "",
                ASI : "",
                BG : "",
                CS : "",
                CS12 : "",
                tratta : ""
            }
        }
        
    }
    
    setOption(option){
       
        this.props.callback(option)
        option ? this.setState({buttonPosition: -10}) : this.setState({buttonPosition: 0})
        this.setState({option})
      }
     
      getZoomPartenza(partenza){
        this.props.markerStart(partenza)
        if(window.innerWidth<768 && partenza) this.props.closeButton()
      }
      getZoomArrivo(arrivo){
        this.props.markerEnd(arrivo)
        if(window.innerWidth<768 && arrivo) this.props.closeButton()
      }

    getResponsePartenzaTariffe(partenza){
       
        //this.props.changePositionTariffaStart(partenza)
        
         //partenza = this.props.positionTariffaStart.positionTariffaStart  
         if(partenza && partenza.lat && partenza.lat!== ""){
                //partenza = this.props.positionTariffaStart.positionTariffaStart 
                this.props.changePositionTariffaStart(partenza) 
                /*if(partenza.lat === undefined){
                    var partenzadati = partenza.split(",")
                    var temp=[]
                    temp.description = partenza
                    temp.lat = partenzadati[0]
                    temp.lng = partenzadati[1]
                    partenza = temp
                }*/
                this.props.markerStart2(partenza)
                this.setState({partenza: partenza});            
                //this.props.changepositionStart({description:`${partenza.description}`,lat:`${partenza.lat}`,lng:`${partenza.lng}`})
                //this.props.changeNomeFermataStart(partenza.description)
                document.getElementById("TariffaId").style.display = "none"
                try {
                    //axios.get(`${window.configFile.httpProxy.urlTariffe}/?action=zona&lat=${partenza.lat}&lng=${partenza.lng}`,{headers:headers})
                    axios.get(`${window.configFile.httpProxy.urlTariffeApi}/zona/${partenza.lat},${partenza.lng}`,{headers:window.tp_headers})
                    .then(response =>{this.setState({dataPartenza:{ID:response.data.ID,NOME: response.data.NOME}}); this.Tariffe()}) 
                    
                } catch (error) {}
            
        }  else {
            document.getElementById("TariffaId").style.display = "none"
            this.setState({dataPartenza:{ID:0,NOME: ''}})
            this.props.markerStart2([])
            this.setState({partenza: null});
            //this.props.changepositionStart(null)
            //this.props.changeNomeFermataStart(null)
          }
        
        /* try {
      
          const partenzaString = `${partenza.lat}%2C${partenza.lng}`
          const arrivoString = `${this.state.arrivo.lat}%2C${this.state.arrivo.lng}`
          const time = `${this.state.date.getHours()}%3A${this.state.date.getMinutes()}`
          const date = `${this.state.date.getMonth()+1}-${this.state.date.getDate()}-${this.state.date.getFullYear()}`
          const mode = this.getTipoMezzo(this.state.mezzo)
          const arriveBy = `${this.state.partenzaArrivo}`
          const wheelchair = `${this.state.accessibilita}`
          var url = ""
          this.state.option ? url = `${window.configFile.httpProxy.url}/routers/default/plan?fromPlace=${partenzaString}&toPlace=${arrivoString}&mode=${mode}&time=${time}&date=${date}&arriveBy=${arriveBy}&maxWalkDistance=750&wheelchair=${wheelchair}&locale=it`  : url = `${window.configFile.httpProxy.url}/routers/default/plan?fromPlace=${partenzaString}&toPlace=${arrivoString}&mode=${mode}&maxWalkDistance=750&wheelchair=${wheelchair}&locale=it`
         
         this.callFetch(url,this.state.ordinamento)
        } catch (error) {
          
        } */
        //document.getElementsByClassName("boxTitolo3").style.display = "block"
    }
    

    getResponseArrivoTariffe(arrivo){
      
        if(arrivo && arrivo.lat && arrivo.lat!== ""){
            this.props.markerEnd2(arrivo)
            this.setState({arrivo: arrivo});
            this.props.changePositionTariffaEnd(arrivo)
            //this.props.changeNomeFermataEnd(arrivo.description)
            document.getElementById("TariffaId").style.display = "none"
            try{
            //axios.get(`${window.configFile.httpProxy.urlTariffe}/?action=zona&lat=${arrivo.lat}&lng=${arrivo.lng}`,{headers:headers})
                    axios.get(`${window.configFile.httpProxy.urlTariffeApi}/zona/${arrivo.lat},${arrivo.lng}`,{headers:window.tp_headers})
            .then(response =>{this.setState({dataArrivo:{ID:response.data.ID,NOME: response.data.NOME}}); this.Tariffe()})  
            }  catch (error) {
                
            } 
        }  else {
                document.getElementById("TariffaId").style.display = "none"
                this.setState({dataArrivo:{ID:0,NOME: ''}})
                this.props.markerEnd2([])
                this.setState({arrivo: null});
                //this.props.changepositionEnd(null)
                //this.props.changeNomeFermataEnd(null)
              }
      
      /* try {
      
        const partenzaString = `${this.state.partenza.lat}%2C${this.state.partenza.lng}`
        
        const arrivoString = `${arrivo.lat}%2C${arrivo.lng}`
        
        const time = `${this.state.date.getHours()}%3A${this.state.date.getMinutes()}`
        const date = `${this.state.date.getMonth()+1}-${this.state.date.getDate()}-${this.state.date.getFullYear()}`
        const mode = this.getTipoMezzo(this.state.mezzo)
        const arriveBy = `${this.state.partenzaArrivo}`
        const wheelchair = `${this.state.accessibilita}`
        var url = ""
        this.state.option ? url = `${window.configFile.httpProxy.url}/routers/default/plan?fromPlace=${partenzaString}&toPlace=${arrivoString}&mode=${mode}&time=${time}&date=${date}&arriveBy=${arriveBy}&maxWalkDistance=750&wheelchair=${wheelchair}&locale=it`  : url = `${window.configFile.httpProxy.url}/routers/default/plan?fromPlace=${partenzaString}&toPlace=${arrivoString}&mode=${mode}&maxWalkDistance=750&wheelchair=${wheelchair}&locale=it`
       this.callFetch(url,this.state.ordinamento)
      } catch (error) {
        
      } */
      
    }
       

    reset(){
        //document.getElementById("TariffaId").style.display = "none"
        //document.getElementById("AvvertenzeId").style.display= "none"
       // window.location.replace(window.location.href.split("?")[0]);
        
        this.props.markerStart2([])
        this.props.markerEnd2([])
        this.setState({partenza: null});
        this.setState({arrivo: null});
        this.setState({dataArrivo: {ID: 0,NOME: ""}});
        this.setState({dataPartenza: {ID: 0,NOME: ""}});
        this.props.changePositionTariffaStart(null)
        this.props.changePositionTariffaEnd(null)
        document.getElementById("TariffaId").style.display = "none"
        document.getElementById("AvvertenzeId").style.display = "none"
    }
    Avvertenze(avvertenza){
       
        if(avvertenza === false){
        document.getElementById("AvvertenzeId").style.display = "block"
        //this.state.avvertenza = true
        this.setState({avvertenza: true});
       
        }else{
            document.getElementById("AvvertenzeId").style.display = "none"
            //this.state.avvertenza = false
            this.setState({avvertenza: false});
        }
        document.getElementById("TariffaId").style.display = "none"
        
    }

     Tariffe() {
        
        if(this.state.dataPartenza.ID !== 0 && this.state.dataArrivo.ID !== 0){
            //axios.get(`${window.configFile.httpProxy.urlTariffe}/?action=tariffe&origine=${this.state.dataPartenza.ID}&destinazione=${this.state.dataArrivo.ID}`,{headers:headers})
            axios.get(`${window.configFile.httpProxy.urlTariffeApi}/tariffe/${this.state.dataPartenza.ID}/${this.state.dataArrivo.ID}`,{headers:window.tp_headers})
            .then(response => {                
                this.setState({tariffe:{AAI:response.data.AAI,AAO65:response.data.AAO65,AAS:response.data.AAS,AMI:response.data.AMI,AMO65:response.data.AMO65,AMS:response.data.AMS,ASI:response.data.ASI,BG:response.data.BG,CS:response.data.CS,CS12:response.data.CS12,tratta: response.data.tratta}})
            })
            
            document.getElementById("TariffaId").style.display = "block"
            document.getElementById("AvvertenzeId").style.display = "none"
        }
    }
        ListaTariffe(){
        return (<div id="TariffaId">
                <table className='tableTariffa'>
                <tbody>
                    <tr className={"divBianco"}>
                            <td colspan="2" className={"tratta_text"}>{i18n.t("Tratta Tariffaria")}:</td>
                            <td></td>
                            <td className={"tratta_num"}>{this.state.tariffe.tratta}</td>
                        </tr>
                         {/* &emsp;  */}
                         <tr className='divideTr'></tr>
                        <tr className={"divBianco"}>
                            <td colspan="2" className={"grassetto"}>{i18n.t("Titolo di viaggio")}</td>
                            <td></td>
                            <td className={"grassetto"}>{i18n.t("Tariffa")} (€)</td>
                        </tr>
                        <tr className='divideTr'></tr>
                        
                        <tr className={"divBianco"}>
                            <td className={"colorBiglietti"}>CS</td>
                            <td className={"styleTitoli"}>{i18n.t("CORSA SEMPLICE")}</td>
                            <td></td>
                            <td className={"grassetto"}>{this.state.tariffe.CS}</td>
                        </tr>
                        {/* <tr className='divideTr'></tr> */}
                        {/* &ensp; */}
                        <tr className={"divBianco"}>
                            <td className={"colorBiglietti"}>BG</td>
                            <td className={"styleTitoli"}>{i18n.t("BIGLIETTO GIORNALIERO 24 ORE")}</td>
                            <td></td>
                            <td className={"grassetto"}>{this.state.tariffe.BG}</td>
                        </tr>
                        {/* <tr className='divideTr'></tr> */}
                        {/* &ensp; */}
                        <tr className={"divBianco"}>
                            <td className={"colorBiglietti"}>CS12</td>
                            <td className={"styleTitoli"}>{i18n.t("CARNET 12 CORSE SEMPLICI")}</td>
                            <td></td>
                            <td className={"grassetto"}>{this.state.tariffe.CS12}</td>
                        </tr>
                      {/*   <tr className='divideTr'></tr>
                        <tr className='divideTr'></tr> */}
                        <tr className={"divBianco"}>
                            <td className={"colorAbbonamentiOrange"}>ASI</td>
                            <td className={"styleTitoli"}>{i18n.t("ABBONAMENTO SETTIMANALE ORDINARIO IMPERSONALE")}</td>
                            <td></td>
                            <td className={"grassetto"}>{this.state.tariffe.ASI}</td>
                        </tr>
                       {/*  <tr className='divideTr'></tr> */}
                        {/* &ensp; */}
                        <tr className={"divBianco"}>
                            <td className={"colorAbbonamentiOrange"}>AMI</td>
                            <td className={"styleTitoli"}>{i18n.t("ABBONAMENTO MENSILE ORDINARIO IMPERSONALE")}</td>
                            <td></td>
                            <td className={"grassetto"}>{this.state.tariffe.AMI}</td>
                        </tr>
                        {/* <tr className='divideTr'></tr> */}
                        {/* &ensp; */}
                        <tr className={"divBianco"}>
                            <td className={"colorAbbonamentiOrange"}>AAI</td>
                            <td className={"styleTitoli"}>{i18n.t("ABBONAMENTO ANNUALE ORDINARIO IMPERSONALE")}</td>
                            <td></td>
                            <td className={"grassetto"}>{this.state.tariffe.AAI}</td>
                        </tr>
                        {/* <tr className='divideTr'></tr> */}
                        {/* &ensp; */}
                        <tr className={"divBianco"}>
                            <td className={"colorAbbonamentiGreen"}>AMS</td>
                            <td className={"styleTitoli"}>{i18n.t("ABBONAMENTO MENSILE STUDENTE")}</td>
                            <td></td>
                            <td className={"grassetto"}>{this.state.tariffe.AMS}</td>
                        </tr>
                        {/* <tr className='divideTr'></tr> */}
                        {/* &ensp; */}
                        <tr className={"divBianco"}>
                            <td className={"colorAbbonamentiGreen"}>AAS</td>
                            <td className={"styleTitoli"}>{i18n.t("ABBONAMENTO ANNUALE STUDENTE")}</td>
                            <td></td>
                            <td className={"grassetto"}>{this.state.tariffe.AAS}</td> 
                        </tr>
                        {/* <tr className='divideTr'></tr> */}
                        {/* &ensp; */}
                        <tr className={"divBianco"}>
                            <td className={"colorAbbonamentiBlue"}>AMO65</td>
                            <td className={"styleTitoli"}>{i18n.t("ABBONAMENTO MENSILE OVER65")}</td>
                            <td></td>
                            <td className={"grassetto"}>{this.state.tariffe.AMO65}</td>
                        </tr>
                        {/* <tr className='divideTr'></tr> */}
                        {/* &ensp; */}
                        <tr className={"divBianco"}>
                            <td className={"colorAbbonamentiBlue"}>AAO65</td>
                            <td className={"styleTitoli"}>{i18n.t("ABBONAMENTO ANNUALE OVER65")}</td>
                            <td></td>
                            <td className={"grassetto"}>{this.state.tariffe.AAO65}</td>
                        </tr> 
                   
                    </tbody>
                </table>
            </div>)}
        
        
    


    render(){
        return(<div >
            <div className={"percorsoDiv"}>
                <br></br>
                
                <div className="AAA">
                
                <SearchBarTariffa titolo="Parti da" placeholder="Scrivi qui il tuo punto di partenza"  callback={this.getResponsePartenzaTariffe.bind(this) } callback2={this.getZoomPartenza.bind(this)}  stato={this.state.partenza} dataFermate={this.state.dataFermate} /* allback={this.getZonaTariffariaPartenza.bind(this)} */  ></SearchBarTariffa>
                
                
                <div className="contenitoreRicerca3">
                
                <Grid item xs={6}>
                 <div className="boxTitolo3" id="fermataTariffaria"><Trans>Fermata Tariffaria</Trans>:</div> </Grid>
                    {/* <div className={'searchContainer3'}>  */}
                         {/* <TextField value={this.state.dataPartenza.NOME} aria-readonly={true} InputLabelProps={{style: {fontSize: 1, color: "gray", position:'relative', bottom:10,left: -40}}} />  */}
                         <Grid item xs={6}>  <label className="labelstyle">{this.state.dataPartenza.NOME}</label></Grid>
                    {/* </div> */}
                    
                 </div> 
                 
                </div>
                <div className="BBB">
                <SearchBarTariffa2 titolo="Arriva a" placeholder="Scrivi qui il tuo punto di destinazione"  callback={this.getResponseArrivoTariffe.bind(this)} callback2={this.getZoomArrivo.bind(this)} stato={this.state.arrivo} ></SearchBarTariffa2>
                
                <div className="contenitoreRicerca3">
                <Grid item xs={6}><div className="boxTitolo4" ><Trans>Fermata Tariffaria</Trans>:</div></Grid>
                    {/* <div className={'searchContainer3'}> 
                            <TextField value={this.state.dataArrivo.NOME} aria-readonly={true} InputLabelProps={{style: {fontSize: 1, color: "gray", position:'relative', bottom:10,left: -40}}} />
                    </div> */}
                     <Grid item xs={6}> <label className="labelstyle">{this.state.dataArrivo.NOME}</label></Grid>
                </div>
                </div>
                
                <div className={"TariffaDiv_text"}>{i18n.t("String_attenzione")}</div>
            <div className={"calcolaButton tariffaCalcolaButton"}>
                        <button className={"buttonStyle"} onClick={ () => this.Tariffe()} ><Trans>Calcola tariffa</Trans></button>
                       <button className={"resetStyle"} onClick={() => this.reset()} >Reset</button>
                       <Tooltip title="Informazioni"><img src={point} alt="Arrow" className={"PointImage"} onClick={() => this.Avvertenze(this.state.avvertenza)}></img></Tooltip>
            </div>
           {/*  <br></br>
            
            <div >
                
                <button className={"AvvertenzaButton"} onClick={() => this.Avvertenze(this.state.avvertenza)}>Avvertenze !</button>
            </div>  */}
            <br></br>
            </div>
            <div className="listaTariffe" >
                    {this.ListaTariffe()} 
                    <div /* className={"parData2"} */ id={"AvvertenzeId"} className={"AvvertenzaList"}>
                    <h1><Trans>COME FUNZIONA</Trans></h1>
					<p className={"misuraTesto"}>1)	{i18n.t("String_infotariffa_1")}</p>
					<p className={"misuraTesto"}>2)	{i18n.t("String_infotariffa_2")}</p>
					<p className={"misuraTesto"}>3)	{i18n.t("String_infotariffa_2")}</p>
                    <p >
                        <img src={startFlag} alt="Partenza" title="Partenza"></img>
                        <Trans>indica la partenza</Trans>
                        <img src={finishFlag} alt="Arrivo" title="Arrivo"></img>
                        <Trans>indica l'arrivo</Trans>
                    </p>
					<h1><Trans>AVVERTENZE</Trans></h1>
					<p className={"testoSinistra"}><b>{i18n.t("String_infotariffa_4")}</b></p>
					<p className={"misuraTesto"}>{i18n.t("String_infotariffa_5")}</p>
					<p className={"misuraTesto"}>{i18n.t("String_infotariffa_6")} <a href={i18n.t("String_infotariffa_LINK")}><Trans>tariffe</Trans></a>.</p>
					<p className={"misuraTesto"}>{i18n.t("String_infotariffa_7")}</p>                   
                    
                </div>
            </div>
            
        </div>)
    }
    
    




}
const mapStateToProps = state => {
    return {
        pathData: state.path,
        indexData: state.index,
        positionStart: state.positionStart,
        positionEnd: state.positionEnd,
        markerStart: state.markerStart,
        markerEnd: state.markerEnd,
        markerStart2: state.markerStart2,
        markerEnd2: state.markerEnd2,
        positionTariffaStart : state.positionTariffaStart,
        nomeFermataStart : state.nomeFermataStart,
        nomeFermataEnd : state.nomeFermataEnd
  
    }
  }
  
  const mapDispatchToProps = dispatch => {
    return {
        fetchPath: (url,nome) => dispatch(fetchPath(url,nome)),
        selectIndex: (index) => dispatch(selectNewIndex(index)),
        markerStart: (marker) => dispatch(selectNewMarkerStart(marker)),
        markerEnd: (marker) => dispatch(selectNewMarkerEnd(marker)),
        markerStart2: (marker) => dispatch(selectNewMarkerStart2(marker)),
        markerEnd2: (marker) => dispatch(selectNewMarkerEnd2(marker)),
        changePositionTariffaStart:(positionTariffaStart) => dispatch(changePositionTariffaStart(positionTariffaStart)),
        changePositionTariffaEnd:(positionTariffaEnd) => dispatch(changePositionTariffaEnd(positionTariffaEnd)),
        changepositionStart: (positionStart) => dispatch(changepositionStart(positionStart)),
        changepositionEnd: (positionEnd) => dispatch(changepositionEnd(positionEnd)),
        changeNomeFermataStart :(nomeFermataStart) => dispatch(changeNomeFermataStart(nomeFermataStart)),
        changeNomeFermataEnd :(nomeFermataEnd) => dispatch(changeNomeFermataEnd(nomeFermataEnd))
    }
  }
export default connect(mapStateToProps,mapDispatchToProps)(TariffaList)